module.exports = __webpack_public_path__ + "6b0640d2787e9477b8f7085512136acb.png";